import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'
import GaiaLogo, { TYPE_WHITE } from '../../GaiaLogo/GaiaLogo'
import Button, { TYPES } from '../../Button/index'
import IconV2, { ICON_TYPES } from '../../Icon.v2/index'
import { H1 } from '../../Heading/index'

/**
 * Title Gradient component on Onbording page (left side)
 * @param {Object} props - The props
 * @param {Map} props.copy - Translation text
 * @param {String} props.title - Title of text
 * @param {String} props.description - Description of text
 * @param {Function} props.handleBackClick - Function for back click button
 * @param {Function} props.handleSkipClick - Function for skip click button
 * @returns {JSX.Element} - Title Gradient
 */
const titleGradient = (props) => {
  const {
    copy,
    title,
    description,
    handleBackClick,
    // handleSkipClick,
    screenNumber,
    duration,
  } = props

  const blobNumber = screenNumber || 1

  return (
    <div
      className={`onboarding-title-gradient onboarding-title-gradient__${blobNumber} onboarding-title-gradient__${duration ? 'duration' : ''}`}
    >
      <div className="onboarding-title-gradient__logo-container">
        <GaiaLogo
          type={TYPE_WHITE}
          className={['onboarding__logo']}
        />
      </div>
      <div className="onboarding-title-gradient__container">
        <div className="onboarding-title-gradient__text-container">
          <H1 inverted className="onboarding-title-gradient__title">
            {title}
          </H1>
          <p className="onboarding-title-gradient__description">
            {description}
          </p>
        </div>
      </div>
      <div className="onboarding-title-gradient__button-container">
        <div>
          <Button
            type={TYPES.LINK}
            onClick={handleBackClick}
            className="onboarding-title-gradient__button"
          >
            <IconV2 type={ICON_TYPES.CHEVRON_LEFT} />
            <span className="onboarding-title-gradient__button-text">{copy.get('back')}</span>
          </Button>
        </div>
        {/* {(handleSkipClick) && (
          <div>
            <Button
              type={TYPES.LINK}
              onClick={handleSkipClick}
              className="onboarding-title-gradient__button"
            >
              <span className="onboarding-title-gradient__button-text">
                {copy.get('skip') || 'Skip'}
              </span>
              <IconV2
                type={ICON_TYPES.CHEVRON_RIGHT}
                className="onboarding-title-gradient__right"
              />
            </Button>
          </div>
        )} */}
      </div>
    </div>
  )
}

titleGradient.propTypes = {
  title: PropTypes.string.isRequired,
  copy: ImmutablePropTypes.map.isRequired,
  description: PropTypes.string.isRequired,
  handleBackClick: PropTypes.func.isRequired,
  handleSkipClick: PropTypes.func,
  screenNumber: PropTypes.number,
  duration: PropTypes.number,
}

export default titleGradient
